import { ajaxSurvey } from "./poll_utils.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	window.globalLoginWindowHandler.pollLogin(
		document.querySelectorAll("._submit_survey_form"),
	);

	for (const el of document.querySelectorAll("._submit_survey_form")) {
		el.addEventListener("click", (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			const form = event.currentTarget.closest("form");
			ajaxSurvey(form);
		});
	}
});
